export default __webpack_public_path__ + "static/media/zeldle8.91387d8f.png";